import { Modal, Button, Text } from '@msc-b2c/shared-components';
import styles from '../../PostBookingResultsWrapper.module.scss';

export function CannotBookPopUp({
  modalTitle,
  modalBodyText,
  modalButtonLabel,
  handleClose,
  handleClick,
}: Readonly<{
  modalTitle: string;
  modalBodyText: string;
  modalButtonLabel: string;
  handleClose: () => void;
  handleClick: () => void;
}>) {
  return (
    <Modal
      onClose={handleClose}
      styleOption={`-modal-private-area`}
    >
      <div className={styles['cmp-container__modal-header']}>
        <Text
          text={modalTitle}
          styleOption="cmp-text__big bold"
        />
      </div>
      <div className={styles['cmp-container__modal-body']}>
        <Text
          text={modalBodyText}
          styleOption="cmp-text__normal"
        />
      </div>
      <div className={styles['cmp-container__modal-buttons']}>
        <Button
          text={modalButtonLabel}
          styleOption="cmp-button__primary"
          onClick={handleClick}
        />
      </div>
    </Modal>
  );
}
